module.exports = {
	"id": "NE",
	"name": "Niger",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.000644,
			"9": null,
			"10": null,
			"11": 0.019964,
			"12": 0.002576,
			"13": 0.000644,
			"14": null,
			"15": 0.001288,
			"16": null,
			"17": 0.002576,
			"18": null,
			"19": 0.001288,
			"20": 0.001932,
			"21": 0.005152,
			"22": 0.001288,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.005796,
			"27": 0.001932,
			"28": 0.001288,
			"29": 0.000644,
			"30": 0.003864,
			"31": 0.007728,
			"32": 0.002576,
			"33": 0.010304,
			"34": null,
			"35": 0.001932,
			"36": 0.001288,
			"37": 0.003864,
			"38": 0.003864,
			"39": 0.003864,
			"40": 0.007084,
			"41": 0.001932,
			"42": 0.00322,
			"43": 0.017388,
			"44": 0.001288,
			"45": 0.184828,
			"46": 0.002576,
			"47": 0.004508,
			"48": 0.074704,
			"49": 0.047012,
			"50": 0.018032,
			"51": 0.047012,
			"52": 0.049588,
			"53": 1.057448,
			"54": 0.209944,
			"55": 0.00322,
			"56": 0.001932,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.088872,
			"4": 0.001288,
			"5": 0.001288,
			"6": 0.001288,
			"7": 0.001932,
			"8": 0.001288,
			"9": 0.001932,
			"10": 0.001288,
			"11": 0.001288,
			"12": 0.018676,
			"13": 0.001932,
			"14": 0.001288,
			"15": 0.026404,
			"16": 0.011592,
			"17": 0.002576,
			"18": 0.001288,
			"19": 0.014168,
			"20": 0.001932,
			"21": 0.010304,
			"22": 0.004508,
			"23": 0.002576,
			"24": 0.005796,
			"25": 0.007728,
			"26": 0.003864,
			"27": 0.00322,
			"28": 0.000644,
			"29": 0.008372,
			"30": 0.01288,
			"31": 0.00966,
			"32": 0.000644,
			"33": 0.013524,
			"34": 0.01288,
			"35": 0.005796,
			"36": 0.00644,
			"37": 0.012236,
			"38": 0.005796,
			"39": 0.015456,
			"40": 0.012236,
			"41": 0.015456,
			"42": 0.00966,
			"43": 0.10948,
			"44": 0.037352,
			"45": 0.05152,
			"46": 0.02254,
			"47": 0.1932,
			"48": 0.224112,
			"49": 0.820456,
			"50": 0.030912,
			"51": 0.001288,
			"52": 0.001288,
			"3.5": 0.005152,
			"3.6": 0.005796
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": 0.000644,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.002576,
			"21": null,
			"22": 0.000644,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.005152,
			"30": 0.005152,
			"31": null,
			"32": 0.002576,
			"33": 0.001932,
			"34": 0.001288,
			"35": 0.021896,
			"36": 0.014812,
			"37": 0.10948,
			"38": 0.005796,
			"39": 0.021252,
			"40": 0.085652,
			"41": 0.014168,
			"42": 0.00322,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.000644,
			"11.1": 0.003864,
			"11.5": 0.000644,
			"11.6": 0.001932,
			"12.1": 0.002576
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.000644,
			"6": null,
			"7": 0.005796,
			"8": 0.004508,
			"9": 0.003864,
			"10": 0.01932,
			"3.1": null,
			"3.2": null,
			"5.1": 0.002576,
			"6.1": 0.037996,
			"7.1": null,
			"9.1": 0.077924
		},
		"ios_saf": {
			"8": 0,
			"10": 0.409326947544,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0110308875937,
			"8.1-8.4": 0.0203790974188,
			"9.0-9.2": 0.00972213821815,
			"9.3": 0.148324929226
		},
		"android": {
			"3": 0,
			"4": 0.119307131783,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0149133914729,
			"4.1": 0.430357868217,
			"4.2-4.3": 1.07589467054,
			"4.4": 2.46710104651,
			"4.4.3-4.4.4": 2.48840589147
		},
		"ie": {
			"6": 0.00328874157303,
			"7": 0.00591973483146,
			"8": 0.126945424719,
			"9": 0.0328874157303,
			"10": 0.0572241033708,
			"11": 0.359130579775,
			"5.5": null
		},
		"op_mob": {
			"0": 3.87644876892,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.10767913247
		},
		"edge": {
			"12": 0.028336,
			"13": 0.066332,
			"14": 0.019964
		},
		"ie_mob": {
			"10": 0.125449464789,
			"11": 0.510758535211
		},
		"bb": {
			"7": 0.032746,
			"10": null
		},
		"samsung": {
			"0": 0.645564
		},
		"and_uc": {
			"0": 9.047252
		},
		"op_mini": {
			"0": 52.2267200986
		},
		"and_chr": {
			"0": 20.4732
		},
		"and_ff": {
			"0": 0.346172
		}
	},
	"total": 99.426414
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NE.json
 ** module id = 606
 ** module chunks = 0
 **/